import { render, staticRenderFns } from "./TaskInfoModalInfo.vue?vue&type=template&id=f02cbcbe&scoped=true"
import script from "./TaskInfoModalInfo.vue?vue&type=script&lang=js"
export * from "./TaskInfoModalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02cbcbe",
  null
  
)

export default component.exports